// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2l4gK","content":"styles_content__3s5ds"};